declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_simple_two_classes_foo extends $mol_object {
		str( ): string
	}
	
	export class $mol_view_tree2_to_js_test_ex_simple_two_classes_bar extends $mol_view_tree2_to_js_test_ex_simple_two_classes_foo {
		str( ): string
	}
	
}

//# sourceMappingURL=simple_two_classes.view.tree.d.ts.map